export default function filled(value, extra) {
  const trimmed = typeof value === 'string' ? value.trim() : value;

  return ![null, undefined, '', extra].includes(trimmed);
}
